module.exports = __webpack_public_path__ + "img/dirty.9bdf8910.png";